export const ENotificationType = {
  "0": "UNKNOWN",
  "1": "TASK_CHAT",
  "2": "TASK_ASSIGN",
  "3": "TASK_EMAIL",
  "4": "INVOICE_CREATE",
  "5": "NOTIFICATION",
  "6": "HOTEL_CONTENT_COMPLETED",
  "7": "HOTEL_REFERENCE_COMPLETED",
  "8": "FLIGHT_PENDING_PNR_SUCCEDEED",
  "9": "FLIGHT_PENDING_PNR_FAILED",
  "10": "FLIGHT_CHANGE_CONFIRMATION",
  "-1": "ALL"
};

export const ENotificationStatus = {
  "0": "UNKNOWN",
  "1": "SENT",
  "2": "DELIVERED",
  "3": "READ",
  "4": "ERASED",
  "-1": "ALL"
};

export const EAnnouncementCategory = {
  "0": "UNKNOWN",
  "1": "ANNOUNCEMENT",
  "2": "CAMPAIGN",
  "-1": "ALL"
};